define((require) => {
    "use strict";

    const {defer, keys, pick}           = require("underscore");
    const Marionette                    = require("marionette");
    const TextEditorModel               = require("ui/experience/widgets/textEnhancedWidget/textEditor/TextEditorModel");

    /**
     * A controller that correlates between text widget and text editor
     */
    return Marionette.Controller.extend({
        /**
         * The text widget element as jQuery object
         * @private
         */
        $el: null,

        /**
         * The text widget model
         * @private
         */
        _textWidgetModel: null,

        /**
         * The text widget view that embeds the actual text editor
         * @private
         */
        _textWidgetView: null,

        /**
         * Initialization
         * @param {TextWidgetView} textWidgetView   The text widget view
         */
        initialize(textWidgetView) {
            this._textWidgetView = textWidgetView;
            this._textWidgetModel = this._textWidgetView.model;
            this.$el = this._textWidgetView.$el;

            this._editorModel = new TextEditorModel();
            this.updateEditorModelFromWidgetModel();

            // This will trigger the textWidgetView to re-render, which in turn
            // will call this class and end up that we create two ckeditors,
            // therefore lets be silent
            this._textWidgetModel.set("editorModel", this._editorModel, {silent: true});
            this.listenTo(this._textWidgetModel, "dropped:to:scene", this._onWidgetDrop);
        },

        /**
         * Trigger update in order to update the free transform handlers
         *
         * In addition, the content change will possibly affect the height of the widget.
         * we need to trigger change of height on the model in order to update the vertical scroll bar, if needed
         *
         * @private
         */
        _contentChangeHandler() {
            this._textWidgetView.trigger("update");
            this._textWidgetModel.trigger("change:height");
        },

        /**
         * Copy values from textWidgetModel to editorModel so that the property view
         * reflects the attributes of textWidgetModel.
         */
        updateEditorModelFromWidgetModel() {
            const attrs = pick(this._textWidgetModel.attributes, keys(TextEditorModel.prototype.defaults));

            // Pass cssUpdate to stop the cyclic callbacks.
            this._editorModel.set(attrs, {"cssUpdate": false});
        },

        _onWidgetDrop() {
            defer(() => {
                if (!this._textWidgetModel.get("isSelected")) {
                    this._textWidgetModel.set("isSelected", true);
                }
            });
        },

        onClose() {
            this._editorModel.destroy();
            this._editorModel = null;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/textEnhancedWidget/textEditor/TextEditorController.js